import _concat from 'lodash/concat';
import deepmerge from 'deepmerge';
const combineMerge = (destination, source) => {
  const array = destination.concat(source);
  return Array.from(new Set(array));
};
export default (state, action, _ref) => {
  let {
    types
  } = _ref;
  switch (action.type) {
    case types.UPDATE_CREDIT_APP_DEALS:
      {
        return {
          ...state,
          creditAppDeals: deepmerge(state.creditAppDeals, action.payload?.creditAppDeals, {
            arrayMerge: combineMerge
          })
        };
      }
    case types.ADD_HIDE_RECEIPT_LISTING:
      {
        const hideReceipt = _concat(state?.hideReceipt, [action.payload.listingId]);
        return {
          ...state,
          hideReceipt
        };
      }
    case types.REMOVE_HIDE_RECEIPT_LISTING:
      {
        const listingIds = state?.interactions?.hideReceipt?.filter(item => item !== action.payload.listingId) ?? [];
        return {
          ...state,
          hideReceipt: listingIds
        };
      }
    case types.SET_DEAL_DETAILS:
      {
        return {
          ...state,
          dealDetails: {
            ...state.dealDetails,
            ...action.payload
          }
        };
      }
    case types.UPDATE_DEAL_DETAILS:
      {
        const {
          dealId,
          dealData
        } = action.payload;
        return {
          ...state,
          dealDetails: {
            ...state.dealDetails,
            [dealId]: {
              ...state.dealDetails[dealId],
              ...dealData
            }
          }
        };
      }
    case types.UPDATE_DEAL_NOTIFICATIONS:
      {
        return {
          ...state,
          dealNotifications: {
            ...state.dealNotifications,
            ...action.payload
          }
        };
      }
    case types.RESET_DEAL_NOTIFICATIONS:
      {
        return {
          ...state,
          dealNotifications: {}
        };
      }
    case types.SET_DEALS_OBJ:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    default:
      return state;
  }
};